<template>
  <div
    :class="['video', value.shadow ? '-shadow' : '', value.bordered ? '-bordered' : '']"
  >
    <video
      :src="value.videoSrc"
      :autoplay="value.autoPlay"
      muted
      loop
      playsinline
      preload="auto"
      width="100%"
      height="auto"
    />
  </div>
</template>

<script setup>
defineProps({
  value: {
    type: Object,
    required: true,
  },
});
</script>

<style lang="scss" scoped>
  .video {
    width: 100%;
    height: 100%;
    border-radius: .4rem;
    overflow: hidden;
    display: flex;

  &.-shadow {
    box-shadow: rgb(38 50 56 / 10%) 0 0 0 1px, rgb(38 50 56 / 10%) 0 2px 4px;
  }

  &.-bordered {
    border: 1px solid $border-color;
    border-radius: .4rem;
  }
}

</style>
